// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import "~@/css/common_fonts"
import "@hotwired/turbo-rails"
import "@/lib/turbo_streams"

// Report and recover from failed dynamic-import chunk loads. The common cause is a stale
// deploy (the open page references asset hashes that no longer exist) where one reload
// fetches fresh bundles. Reload at most ONCE per tab session — the flag is set before the
// reload and never cleared, so a persistent failure (e.g. a cross-origin CDN/CORS block
// reloading can't fix) cannot trigger an endless loop; component-level fallbacks render
// instead. Reporting to PostHog mirrors the listing_image_error pattern for incidence.
window.addEventListener("vite:preloadError", (event) => {
  window.posthog?.capture("chunk_load_error", {
    message: event?.payload?.message,
    path: window.location.pathname,
  })

  if (sessionStorage.getItem("vitePreloadReloaded")) return

  sessionStorage.setItem("vitePreloadReloaded", "1")
  window.location.reload()
})

$(document).on("turbo:load", () => {
  $("#bouncing-loader").addClass("hidden")
})

Turbo.start()

import lozad from "lozad"

// initializing Lozad for lazy loading images using the native IntersectionObserver api (when available)
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()

import "@/lib/vue/plugins"

import "@/packs/libs/font-awesome/index.js"
import "@/lib/vue/directives"

import "../frontend/cart-counter.js"

import "../frontend/preventBodyScroll.js"
import "../frontend/plugins/colcade.js"
import "../frontend/footerPortals.js"

import "../packs/frontend/blytics.js"
import "../packs/frontend/my/conversations.js"

import "../controllers/"
// Alpine components
import.meta.glob("../frontend/alpine_components/**/*.js", { eager: true })

// Alpine
import "alpine-turbo-drive-adapter"
import Alpine from "alpinejs"
window.Alpine = Alpine
Alpine.start()

// ViewComponent
import.meta.glob("../../components/**/*component.scss", { eager: true })
import.meta.glob("../../components/**/*component.js", { eager: true })
